/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/hand': {
    width: 16,
    height: 16,
    viewBox: '0 0 211 161.55',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" d="M18.1 36.19A18.1 18.1 0 100 18.1a18.09 18.09 0 0018.1 18.09z" _fill="#e25046" fill-rule="evenodd"/><path pid="1" d="M148.23 160.14a5.41 5.41 0 007.62-.34l53.74-58.8a5.41 5.41 0 00-.34-7.62L200.13 85l-61 66.81zM146.79 17.16a12.11 12.11 0 00-14.18-1.59c-13.69 7.76-41.24 23.49-45 26.27a22.91 22.91 0 00-3.11 2.82c-2.46 2.69-3.87 5.71-3.9 8.27-.25-.13-54.6-40.35-54.69-40.43-4.36-3.22-9.27-1.64-12.38 1.77-3.53 3.86-4.73 10.06-.2 14.16L93.78 102a2.57 2.57 0 01.38 3.38 1.51 1.51 0 01-.22.28v.06c-2.55 2.63-8.22 8.67-22.27 6.75l-5.11-.68c-4.86-.64-8.66 1-11 3.57-4.18 4.58-4 12.32 2.84 16.72 9.93 6.44 38.63 15.35 74.44 14l61-66.81-5.34-17.19a35.36 35.36 0 00-10-15.9z"/></g></g>'
  }
})
